"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccordionState = /** @class */ (function () {
    function AccordionState() {
        this.open = false;
        this.class = 'accordion';
    }
    return AccordionState;
}());
exports.default = AccordionState;
//# sourceMappingURL=AccordionState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/Accordion/AccordionState.js
// module id = 2335
// module chunks = 8